import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FeaturedSubcatsContainer from '../../components/category/FeaturedSubcatsContainer';
import HeaderTags from '../../components/header/HeaderTags';
import GiftingBanner from '../../components/popular-gifts-list/GiftingBanner';
import PopularGiftsList from '../../components/popular-gifts-list/PopularGiftsList';
import {
  NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY,
  NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY,
} from '../../config/setup/setup';
import {
  GIFTSCANONICALURL,
  GIFTS_BANNER_DESCRIPTION,
  GIFTSTITLE,
} from '../../config/text/text';
import { isWowcherIE } from '../../helpers/pages';
import ThemeContext from '../../providers/ThemeProvider';
import { getClientSideDeals } from '../../redux/actions/clientRender';
import { getServerSideEssentials } from '../../redux/actions/ssr';
import { getTiles } from '../../redux/actions/tiles';
import { wrapper } from '../../redux/store/store';
import {
  getPopularGifts,
  getSubCategoriesForGifts,
} from '../../services/gifts';

const Gifts = ({ popularGiftsData, subCats }) => {
  const router = useRouter();
  const tiles = useSelector((state) => state.tiles);
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();

  const featuredSubcats = subCats?.subCategories?.filter((subCat) => {
    return subCat.locations.length > 0;
  });
  useEffect(() => {
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    dispatch(
      getClientSideDeals({
        pageSize: NUMBER_OF_DEALS_FIRST_PAGE_ON_CATEGORY,
        path: router.asPath,
        query: {
          ...router.query,
        },
        secondaryDealsCount: NUMBER_OF_SECONDARY_DEALS_ON_CATEGORY,
      }),
    );
  }, []);

  useEffect(() => {
    dispatch(getTiles(router.asPath, tiles.apiUrl, tiles.tiles?.length || 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath]);

  return (
    <>
      <HeaderTags
        canonicalUrl={GIFTSCANONICALURL}
        description={GIFTS_BANNER_DESCRIPTION}
        title={GIFTSTITLE}
      />
      <div className="rel-container">
        <div className="container">
          <GiftingBanner subText={GIFTS_BANNER_DESCRIPTION} />
          <FeaturedSubcatsContainer
            isGifts
            specifiedSubcats={featuredSubcats}
          />
          {popularGiftsData && (
            <PopularGiftsList popularGiftsData={popularGiftsData} />
          )}
        </div>
        <style jsx>{`
          .gifts-title {
            margin-left: 10px;
            color: ${theme.colors.primary};
            margin-top: 5px;
          }
        `}</style>
      </div>
    </>
  );
};
export const getServerSideProps = wrapper.getServerSideProps(
  async ({ req, store }) => {
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });
    const popularGiftsData = isWowcherIE() ? '' : await getPopularGifts();
    const subCats = await getSubCategoriesForGifts();

    return {
      props: {
        popularGiftsData,
        subCats,
      },
    };
  },
);

Gifts.propTypes = {
  popularGiftsData: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  subCats: PropTypes.object,
};
export default Gifts;
